import { h } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../../../../utils/Stores/store';

export function getDriveFields(
  checkEmptyField: boolean,
  changeData: (event: Event, value: string) => void,
) {
  const osVersions = [
    wcShared?.translate('Windows 11'),
    wcShared?.translate('Windows 10'),
    wcShared?.translate('Windows 8.1 ou plus ancien'),
    'macOS Sequoia',
    'macOS Sonoma',
    wcShared?.translate('macOS Ventura ou plus ancien'),
    wcShared?.translate('Linux'),
    wcShared?.translate('Autres'),
  ];

  return (
    <div>
      <select
        class={{
          'input-os': true,
          'no-margin-bottom':
            (Store?.get('messageData')?.drive_os === null ||
              Store?.get('messageData')?.drive_os === '') &&
            checkEmptyField,
        }}
        onChange={(event) => changeData(event, 'drive_os')}
      >
        <option
          value=""
          selected
          disabled
          hidden
        >
          {wcShared?.translate("Version du systeme d'exploitation")}
        </option>
        {osVersions?.map((os) => {
          return <option value={os}>{os}</option>;
        })}
      </select>
      <span
        class={{
          'required-field': true,
          hide:
            (Store?.get('messageData')?.drive_os !== null &&
              Store?.get('messageData')?.drive_os !== '') ||
            !checkEmptyField,
        }}
      >
        {wcShared?.translate('*Champ obligatoire')}
      </span>

      <input
        type="text"
        onKeyPress={(e) => {
          e.stopPropagation();
        }}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
        onKeyUp={(e) => {
          e.stopPropagation();
        }}
        class={{
          'input-app-version': true,
          'no-margin-bottom':
            (Store?.get('messageData')?.drive_app_version === null ||
              Store?.get('messageData')?.drive_app_version === '') &&
            checkEmptyField,
        }}
        placeholder={wcShared?.translate('Version du kDrive')}
        value={Store?.get('messageData')?.drive_app_version}
        onInput={(event) => changeData(event, 'drive_app_version')}
        required
      />
      <span
        class={{
          'required-field': true,
          hide:
            (Store?.get('messageData')?.drive_app_version !== null &&
              Store?.get('messageData')?.drive_app_version !== '') ||
            !checkEmptyField,
        }}
      >
        {wcShared?.translate('*Champ obligatoire')}
      </span>
    </div>
  );
}
